import { isDefinedString } from "et3-type-guards";
import { memoize } from "lodash";
import { observable } from "mobx";

import { apiCallGetUserDevice } from "../../../api/user-api/api-call-get-user-device";
import { apiCallUnlinkUserDevice } from "../../../api/user-api/api-call-unlink-user-device";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class UserDeviceStore {
  deviceIdInput = observable.box<string>("");
  userDevicesData = observable.box<
    {
      userId: number;
      userUUID: string;
      deviceId: string;
      isActive: number;
    }[]
  >([]);
  unlinkDevice = async ({
    userUUID,
    deviceId
  }: {
    userUUID: string;
    deviceId: string;
  }) => {
    const updatedData = this.userDevicesData.get().map((item) => {
      if (item.userUUID === userUUID) {
        return { ...item, isActive: (item.isActive = 0) };
      }
      return item;
    });
    this.userDevicesData.set(updatedData);
    if (!isDefinedString(deviceId) || deviceId === "") {
      return;
    }
    getCoreUIStore().setIsLoading("USER_DEVICES", true);
    const { code, status } = await apiCallUnlinkUserDevice({
      deviceId,
      userUUID
    });
    getCoreUIStore().setIsLoading("USER_DEVICES", false);
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    } else {
      getCorePopUpStore().showSuccessMessage("DEVICE_UNLINKED_SUCCESSFULLY");
    }
    return;
  };
  searchByDeviceId = async () => {
    const deviceId = this.deviceIdInput.get();
    if (!isDefinedString(deviceId) || deviceId === "") {
      return;
    }
    getCoreUIStore().setIsLoading("USER_DEVICES", true);
    const { data, code, status } = await apiCallGetUserDevice({
      deviceId
    });

    this.userDevicesData.set(data);
    getCoreUIStore().setIsLoading("USER_DEVICES", false);
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}
const getUserDeviceStore = memoize(
  () => new UserDeviceStore(),
  () => 1
);
export default getUserDeviceStore;
